import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { Dialog, FormControlLabel, Grid, Switch, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import EasyEdit, { Types } from "react-easy-edit";
import EasyEditCustomTextbox from "../../../components/common/EasyEditCustomTextbox";
import FormGroupStatic from "../../../components/common/FormGroupStatic";
import { EasyEditCancelButton, EasyEditSaveButton } from "../../../components/common/EasyEditButtons";
import EasyEditDateTimePicker from "../../../components/common/EasyEditDateTimePicker";
import useAxios from "../../../hooks/useAxios";
import { useSnackbar } from "../../../components/context/SnackbarContext";
import { displayDate, validateField } from "../../../utils/Utils";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { useLoader } from "../../../components/context/LoaderContext";
import { useNavigate } from "react-router-dom";
import CustomEasyEditField from "components/common/CustomEasyEditField";

function EventDetailsDialog({ onClose, open, eventID, handleReloadFunc }) {
    const navigate = useNavigate();
    const { hideLoader, showLoader, loading } = useLoader();
    const [allowEditInline, setAllowEditInline] = React.useState(true);
    const axiosInstance = useAxios();
    const { showSnackbar } = useSnackbar();
    const [errorMessages, setErrorMessages] = useState({});
    const [backendErrorMessages, setBackendErrorMessages] = useState({});
    const { preferredDateFormat, preTimeZoneKey } = useSelector((state) => state?.user);
    const [event, setEvent] = useState(null);
    const [listData, setListData] = useState(null);
    //const [isAllDay, setIsAllDay] = useState(false);
    const [ErrorInput, setErrorInput] = useState({ error_list: [] });
    const [isAllDayState, setIsAllDayState] = useState(false);
    const [customFields, setCustomFields] = useState([]);
    const [customBackendErrorMessages, setCustomBackendErrorMessages] = useState({});


    useEffect(() => {
        async function fetchData() {
            await getData();
        }
        fetchData();
    }, [eventID]);

    const getData = async () => {
        showLoader()
        await axiosInstance.get('api/activity/edit/' + eventID).then((response) => {
            if (response.status === 200) {
                setEvent(response.data?.data?.record);
                setListData(response?.data?.data);
                //setIsAllDay(response?.data?.data?.record?.is_fullday ? true : false)
                setIsAllDayState(response?.data?.data?.record?.is_fullday ? true : false)
                setCustomFields(response?.data?.data?.customFields || []);
                hideLoader();
                setErrorMessages({})
            }
        }).catch((error) => {
            if (error.response) {
                hideLoader();
                if (error.response.status === 400) {
                    showSnackbar(error.response.data.message, "warning");
                    navigate("/events");
                }
            }
        });
    }


    useEffect(() => {
        setIsAllDayState(isAllDayState);
    }, [isAllDayState]);


    const handleSaveData = async (value, name, type = null, isfull = null) => {

        setBackendErrorMessages({})
        var start_date = event?.start_date
        var end_date = event?.end_date

        if (name === 'start_date') {
            start_date = value;
        }
        if (name === 'end_date') {
            end_date = value;
        }

        if (isfull && !isAllDayState) {
            start_date = moment.utc(start_date).tz(preTimeZoneKey).format('YYYY-MM-DD')
            end_date = moment.utc(end_date).tz(preTimeZoneKey).format('YYYY-MM-DD')
        } else if (!isfull && isAllDayState) {
            start_date = moment.utc(start_date).tz(preTimeZoneKey).format('YYYY-MM-DD HH:mm:ss')
            end_date = moment.utc(end_date).tz(preTimeZoneKey).format('YYYY-MM-DD HH:mm:ss')
        }

        const formData = new FormData();

        formData.append('id', eventID);
        formData.append('name', event?.name);
        formData.append('description', event?.description);
        formData.append('location', event?.location);
        formData.append('type', event?.lead_id ? 'lead' : 'deal');
        formData.append('leadId', event?.lead_id || '');
        formData.append('dealId', event?.deal_id || '');
        formData.append('allDay', isAllDayState ? 'yes' : 'no');
        formData.append('start_date', start_date);
        formData.append('end_date', end_date);

        if (!['start_date', 'end_date'].includes(name)) {
            if (type === 'file') {
                for (let i = 0; i < value.length; i++) {
                    formData.append(`${name}[]`, value[i]);
                }
            } else if (type === 'select') {
                for (let j = 0; j < value.length; j++) {
                    formData.append(`${name}[]`, value[j]);
                }
            } else if (type === 'checkbox' || Array.isArray(value)) {
                for (let k = 0; k < value.length; k++) {
                    formData.append(`${name}[]`, value[k]);
                }
            } else {
                formData.append(name, value === 'N/A' ? '' : value);
            }
        } else {
            // If the dynamic name is 'start_date' or 'end_date', override with formatted value
            const formattedDate = moment.utc(moment(value)).tz(preTimeZoneKey).format('YYYY-MM-DD HH:mm:ss');
            formData.set(name, formattedDate); // `.set` overwrites existing key
        }


        //get value from passing key on obj
        function getValueByKey(recordData, key) {
            return recordData[key];
        }

        // Check if new value and existing value are change than call api
        const newValue = getValueByKey(event, name);

        if (newValue !== value && value !== 'N/A') {
            await axiosInstance.post("api/activity/update", formData).then(response => {
                if (response.status === 200) {
                    hideLoader()
                    showSnackbar(response.data.message, "success");
                    setAllowEditInline(true)
                    handleReloadFunc();
                    getData()
                    setErrorInput({ ...ErrorInput, error_list: '' });
                }
            }).then(json => {

            }).catch(error => {
                if (error.response.status === 422 || error.response.data.validation_errors) {
                    setAllowEditInline(true)
                    const errors = error.response.data.validation_errors;
                    Object.keys(errors).forEach(key => {
                        setBackendErrorMessages({ [key]: errors[key] });
                    });

                    const groupedErrors = {};
                    Object.entries(errors).forEach(([key, value]) => {
                        const baseKey = key.split('.')[0];

                        // Clean the error message:
                        let cleanedMessage = value[0]
                            .replace(/\.\d+/, '')                    // remove ".0", ".1", etc.
                            .replace(/_/g, ' ')                      // replace underscores with spaces
                            .replace(/([a-z])([A-Z])/g, '$1 $2')     // optional: split camelCase if needed
                            .trim();

                        if (!groupedErrors[baseKey]) {
                            groupedErrors[baseKey] = [];
                        }

                        groupedErrors[baseKey].push(cleanedMessage);
                    });
                    setCustomBackendErrorMessages(groupedErrors)
                } else {
                    showSnackbar(error.response.data.message, 'error')
                }
            });
        } else {
            setAllowEditInline(true)
        }

    }


    const handleSwitchChange = (event) => {
        setIsAllDayState(event.target.checked);
        handleSaveData(event.target.checked ? 'yes' : 'no', 'allDay', '', event.target.checked)
        setAllowEditInline(true);
    };

    const handleClick = (e) => {
        setAllowEditInline(false)
    }

    const onCancelEdit = (fieldName) => {
        setErrorMessages({ [fieldName]: '' });
        setAllowEditInline(true);
        setBackendErrorMessages({ [fieldName]: '' })
    }

    const handleValidation = (value, fieldName, displayName, type, isrequired, min, max) => {
        const errorMsg = validateField(value, fieldName, displayName, type, isrequired, min, max);
        setErrorMessages(prevState => ({ ...prevState, [fieldName]: errorMsg }));
        return errorMsg === '';
    };

    return (
        <>
            <Dialog onClose={onClose} open={open}>
                <div className="dialog-title">
                    <h2>Event Details</h2>
                    <Tooltip title="Close">
                        <button className="icon-button dialog-close" onClick={onClose}>
                            <Icon path={mdiClose} color={'currentColor'} size={1} />
                        </button>
                    </Tooltip>
                </div>

                {/* {!loading && */}
                <>
                    <Grid container spacing={1.5}>
                        <Grid item xs={12}>
                            <EasyEdit
                                type={Types.TEXT}
                                onSave={(value) => { handleSaveData(value, 'name') }}
                                onCancel={() => { onCancelEdit('name') }}
                                value={event?.name || "N/A"}
                                allowEdit={allowEditInline}
                                editComponent={<EasyEditCustomTextbox focusCallback={e => { setAllowEditInline(false); }} label="Subject" value={event?.name} errorMessages={errorMessages['name']} />}
                                displayComponent={<FormGroupStatic easyEdit label="Subject" value={event?.name} />}
                                onValidate={(value) => handleValidation(value, 'name', 'Subject')}
                                validationMessage={errorMessages['name']}
                                saveButtonLabel={<EasyEditSaveButton />}
                                cancelButtonLabel={<EasyEditCancelButton />}
                                onFocus={() => handleClick('')}
                            />
                            {backendErrorMessages['name'] && <span className="easy-edit-validation-error">{backendErrorMessages['name']}</span>}
                        </Grid>

                        <Grid item xs={6}>
                            <EasyEdit
                                type={Types.TEXT}
                                onSave={(value) => { handleSaveData(value, 'start_date') }}
                                onCancel={() => { onCancelEdit('start_date') }}
                                format={isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)}
                                value={
                                    event?.start_date ? moment.utc(moment(event?.start_date)).tz(preTimeZoneKey).format(isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)) : null
                                }
                                allowEdit={allowEditInline}
                                editComponent={
                                    <EasyEditDateTimePicker
                                        setAllowEditInline={setAllowEditInline}
                                        format={isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)}
                                        label="Start Date"
                                        value={event?.start_date ? moment.utc(moment(event?.start_date)).tz(preTimeZoneKey).format(isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)) : null}
                                        errorMessages={errorMessages['start_date']}
                                        preferredDateFormat={preferredDateFormat}
                                        isAllDay={!isAllDayState}
                                        setParentValue={(value) => {
                                            handleSaveData(value, 'start_date');
                                        }}
                                    />}
                                displayComponent={<FormGroupStatic easyEdit label="Start Date" value={event?.start_date ? moment.utc(moment(event?.start_date)).tz(preTimeZoneKey).format(isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)) : null} preTimeZoneKey={preTimeZoneKey} preferredDateFormat={preferredDateFormat} />}
                                saveButtonLabel={<EasyEditSaveButton />}
                                cancelButtonLabel={<EasyEditCancelButton />}
                                onFocus={() => handleClick('')}
                            />
                            {backendErrorMessages['start_date'] && <span className="easy-edit-validation-error">{backendErrorMessages['start_date']}</span>}
                        </Grid>

                        <Grid item xs={6}>
                            <EasyEdit
                                type={Types.TEXT}
                                onSave={(value) => { handleSaveData(value, 'end_date') }}
                                onCancel={() => { onCancelEdit('end_date') }}
                                value={
                                    event?.end_date ? moment.utc(moment(event?.end_date)).tz(preTimeZoneKey).format(isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)) : null
                                }
                                allowEdit={allowEditInline}
                                editComponent={
                                    <EasyEditDateTimePicker
                                        setAllowEditInline={setAllowEditInline}
                                        label="End Date"
                                        value={event?.end_date ? moment.utc(moment(event?.end_date)).tz(preTimeZoneKey).format(isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)) : null}
                                        errorMessages={errorMessages['end_date']}
                                        preferredDateFormat={preferredDateFormat}
                                        isAllDay={!isAllDayState}
                                        setParentValue={(value) => {
                                            handleSaveData(value, 'end_date');
                                        }}
                                    />}
                                displayComponent={<FormGroupStatic easyEdit label="End Date" value={event?.start_date ? moment.utc(moment(event?.start_date)).tz(preTimeZoneKey).format(isAllDayState ? displayDate(preferredDateFormat, 'half') : displayDate(preferredDateFormat)) : null} preTimeZoneKey={preTimeZoneKey} preferredDateFormat={preferredDateFormat} />}
                                saveButtonLabel={<EasyEditSaveButton />}
                                cancelButtonLabel={<EasyEditCancelButton />}
                                onFocus={() => handleClick('')}
                            />
                            {backendErrorMessages['end_date'] && <span className="easy-edit-validation-error">{backendErrorMessages['end_date']}</span>}
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={isAllDayState} onChange={handleSwitchChange} />}
                                label="All Day Event"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <EasyEdit
                                type={Types.TEXT}
                                onSave={(value) => { handleSaveData(value, 'location') }}
                                onCancel={() => { onCancelEdit('location') }}
                                value={event?.location || "N/A"}
                                allowEdit={allowEditInline}
                                editComponent={<EasyEditCustomTextbox focusCallback={e => { setAllowEditInline(false); }} label="Location" value={event?.location} errorMessages={errorMessages['location']} />}
                                displayComponent={<FormGroupStatic easyEdit label="Location" value={event?.location || 'N/A'} />}
                                onValidate={(value) => handleValidation(value, 'location', 'Location')}
                                validationMessage={errorMessages['location']}
                                saveButtonLabel={<EasyEditSaveButton />}
                                cancelButtonLabel={<EasyEditCancelButton />}
                                onFocus={() => handleClick('')}
                            />
                            {backendErrorMessages['name'] && <span className="easy-edit-validation-error">{backendErrorMessages['location']}</span>}
                        </Grid>

                        <Grid item xs={12}>
                            <EasyEdit
                                type={Types.TEXT}
                                onSave={(value) => { handleSaveData(value, 'description') }}
                                onCancel={() => { onCancelEdit('description') }}
                                value={event?.description || "N/A"}
                                allowEdit={allowEditInline}
                                editComponent={<EasyEditCustomTextbox focusCallback={e => { setAllowEditInline(false); }} label="Description" value={event?.description} errorMessages={errorMessages['description']} />}
                                displayComponent={<FormGroupStatic easyEdit label="Description" value={event?.description || 'N/A'} />}
                                onValidate={(value) => handleValidation(value, 'description', 'Description')}
                                validationMessage={errorMessages['description']}
                                saveButtonLabel={<EasyEditSaveButton />}
                                cancelButtonLabel={<EasyEditCancelButton />}
                                onFocus={() => handleClick('')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormGroupStatic
                                easyEdit
                                label="Related to"
                                value={
                                    listData?.relatedDisplayName && listData.relatedDisplayName.name ? (
                                        listData.relatedDisplayName.type === 'Lead' ? (
                                            <a href={`/lead-detail/${listData.relatedDisplayName.id}`}>
                                                {listData.relatedDisplayName.name}
                                            </a>
                                        ) : listData.relatedDisplayName.type === 'Deal' ? (
                                            <a href={`/deal-detail/${listData.relatedDisplayName.id}`}>
                                                {listData.relatedDisplayName.name}
                                            </a>
                                        ) : (
                                            listData.relatedDisplayName.name
                                        )
                                    ) : 'N/A'
                                }
                            />
                        </Grid>
                    </Grid>

                    {
                        customFields?.length > 0 &&
                        <>
                            <Typography variant="title-medium-large-semibold" component={'h4'} className="mb-12 mt-24">Custom Fields</Typography>

                            <Grid container spacing={1.5}>
                                {customFields?.length > 0 && customFields.map((field, ids) => (
                                    <Grid item xs={12} key={ids}>
                                        < CustomEasyEditField
                                            key={ids}
                                            field={field}
                                            values={event?.custom_field_values || []}
                                            onSave={handleSaveData}
                                            onCancel={onCancelEdit}
                                            allowEditInline={allowEditInline}
                                            handleSaveData={handleSaveData}
                                            onCancelEdit={onCancelEdit}
                                            setAllowEditInline={setAllowEditInline}
                                            errorMessages={errorMessages}
                                            handleValidation={handleValidation}
                                            handleClick={handleClick}
                                            backendErrorMessages={backendErrorMessages}
                                            customBackendErrorMessages={customBackendErrorMessages}
                                            setCustomBackendErrorMessages={setBackendErrorMessages}
                                            isMultiSelect={((field?.display_type === 'file' || field?.display_type === 'select') && field?.is_multiple === 'yes') ? true : false}
                                            xsValue={12}
                                        />
                                    </Grid>
                                ))}

                            </Grid>
                        </>
                    }
                </>
                {/* } */}
            </Dialog>
        </>
    )
}

export default EventDetailsDialog;
